import packingList from "./../../../src/img/Switzerland/Suggested_Packing_List.pdf";
import styles from "./../../Styles/PackingList.module.scss";

function packinglist() {
  const adapters = {
    href: "https://www.amazon.com/Ireland-Adapter-European-Scotland-Hongkong/dp/B0CHYTBYR6/ref=sr_1_1_sspa?adgrpid=185083349463&dib=eyJ2IjoiMSJ9.x-0ZnvondHbzDsFKih07e4GiXrkkKe0xDfqNbHUC495KW143HPgYWQIc__Y77xY36JnvN-KrxCASpXpAHgm33x0P8F_ndPafSm5yHkudP2VAet8ZezisA3UgcQUCqFr9343GZthWdhm06YobtuibbARy5z5AjpeRplPDLo4RIhuxY9dRP1AozGlBicP2RJlmlKDTWMJEXWAeyHbZHn9KMbIqkdol6cqo5HVQCas_l2Ph2JPCSMMs8VaGZuwC42-ueC9Kxkt279VZWRObWum9jjAMnqTGeyA69pm-ALeCIhE.ReL0cOwdRALhk2THXcjZbRcQ8t1Zc8rNp2gXkLlPR90&dib_tag=se&hvadid=779670191219&hvdev=c&hvexpln=0&hvlocphy=9014427&hvnetw=g&hvocijid=17087210700648838723--&hvqmt=b&hvrand=17087210700648838723&hvtargid=kwd-1170712233074&hydadcr=24168_13516801_2334957&keywords=uk%2Bireland%2Btravel%2Bplug%2Badapter&mcid=9a7dd772288a3400b3cac7f7cb69b969&qid=1767288770&sr=8-1-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&th=1",
    target: "_blank"
  };

  return (
    <div className="pageContainer">
      <p className="title">Suggested Packing List</p>

      <p className="text">
        My advice is to pack light. Most people make the mistake of overpacking.
      </p>

      <p className={`text ${styles.highlightOrange}`}>
        I recommend that you take……
      </p>
      <p className="text">
        A debit card so that you can get British pounds (Northern Ireland) and
        euros (Republic of Ireland) at an ATM.
      </p>
      <p className="text">
        You can take a small amount of American cash, but I wouldn’t take too
        much. Probably best to keep it at $300 or under.
      </p>
      <p className="text">
        I would take one or two credit cards. Most places will accept MasterCard
        and Visa as payment. Check with your bank to see if they charge a 3
        percent international transaction fee. Some do and some do not.
      </p>
      <p className={`text ${styles.highlightBlue}`}>
        LET YOUR BANK(S) KNOW THAT YOU WILL BE IN THE REPUBLIC OF IRELAND AND
        NORTHERN IRELAND AND TO EXPECT CHARGES TO COME THROUGH ON YOUR DEBIT AND
        CREDIT CARDS. IF YOU FAIL TO DO THIS, THEY MAY SHUT DOWN YOUR CARD
        BECAUSE THEY SUSPECT FRAUD.
      </p>
      <p className={`text ${styles.highlightOrange}`}>
        Get your ETA online (see General Information page) and don’t forget your
        passport. Make sure it is valid (not due to expire for at least six
        months after you return home). If not, they will not let you board the
        airplane departing the USA.
      </p>
      <ul className={`text ${styles.list}`}>
        <li>
          Two copies of the main page of your passport (take one copy with you
          and leave one copy at home with someone). If you lose your passport,
          having a copy makes it easier to get a provisional one overseas.
        </li>
        <li>
          If you have medical insurance, take some information or your card with
          you proving you have it.
        </li>
        <li>The weather will be cool so take a jacket.</li>
        <li>Ireland has lots of rain. Take an umbrella.</li>
        <li>
          Clothes--not too many, about 4-5 changes of clothes. You don’t need
          any dress clothes.
        </li>
        <li>
          Laundry soap (very small amount, or you can buy some there and share
          it)
        </li>
        <li>
          Most people hand wash clothes in their hotel room. It is usually very
          expensive to send out your laundry for someone to do it.
        </li>
        <li>
          A washcloth if you use one. Most overseas hotels do not provide this.
        </li>
        <li>
          Adapters to plug in your electronics. Here is the link on Amazon where
          you can order an adapter that will work in the Republic of Ireland and
          Northern Ireland. -{" "}
          <a {...adapters} rel="norferrer" className={styles.link}>
            Click here
          </a>
        </li>
        <li>Medicines and supplements that you usually take.</li>
        <li>Small Bible or Bible app on your phone.</li>
        <li>
          Check with your cell phone provider and see if you can cell coverage
          while in Ireland.
        </li>
        <li>Take good walking/hiking shoes.</li>
        <li>
          Soft ear plugs to block any night noises that might keep you from
          sleeping and to block noisy children on the airplane. You can buy a
          package of these inexpensively at Walmart..{" "}
        </li>
        <li>Most hotels have hairdryers.</li>
        <li>
          I recommend that you don’t take anything that has a heating element in
          it. Curling iron, hair dryer, etc.
        </li>
      </ul>
    </div>
  );
}

export default packinglist;
